'use client';

import { useFavouriteProducts } from '@dealerportal/react-helpers';
import dynamic from 'next/dynamic';
import { FavouritesSidebarSkeleton } from './skeletons/FavouritesSidebarSkeleton';

export const FavouritesSidebarLoader = () => {
  const FavouritesSidebar = dynamic(() => import('./FavouritesSidebar'), {
    loading: () => <FavouritesSidebarSkeleton />,
  });

  const ctx = useFavouriteProducts();

  if (!ctx?.loaded) return null;

  return <FavouritesSidebar />;
};
